/**
 * E2E renderer probe — Playwright drives the grandfathered-allow emit through
 * the real `track()` pipeline via `globalThis.__irisVerificationGateTelemetry`.
 *
 * The e2e user is verified, so EmailVerificationGate never takes the
 * grandfathered path. Jest already covers the gate decision. This probe
 * calls the same `track()` the gate calls so the send-boundary receipt can
 * prove `verification_gate_grandfathered` leaves the app (ENG-4602).
 *
 * Same IRIS_E2E_TEST gate as onboarding-telemetry-probe.ts. No product
 * behaviour. Per rule: stay-in-scope (ai.knowledge/global).
 */
import { EVENT_CATEGORIES } from '#~/analytics/constants/event-categories.js';
import { EVENT_NAMES } from '#~/analytics/constants/event-names.js';
import { track as trackAnalyticsEvent } from '#~/analytics/track.js';

interface VerificationGateTelemetryProbe {
  grandfatheredAllow(args: { surface: string; flag_value: boolean }): void;
}

const isE2eEnabled = (): boolean => {
  try {
    return (
      (globalThis as { window?: { electron?: { process?: { env?: Record<string, string> } } } })
        .window?.electron?.process?.env?.IRIS_E2E_TEST === '1'
    );
  } catch {
    return false;
  }
};

if (isE2eEnabled()) {
  const probe: VerificationGateTelemetryProbe = {
    grandfatheredAllow({ surface, flag_value }): void {
      // Same track() call as gate.tsx VERIFICATION_GATE_GRANDFATHERED.
      void trackAnalyticsEvent({
        category: EVENT_CATEGORIES.ONBOARDING,
        name: EVENT_NAMES.VERIFICATION_GATE_GRANDFATHERED,
        properties: { surface, flag_value }
      });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).__irisVerificationGateTelemetry = probe;
}
